import { render } from "./DashboardRespondents.vue?vue&type=template&id=2b9f6b03"
import script from "./DashboardRespondents.vue?vue&type=script&lang=js"
export * from "./DashboardRespondents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__